<template>
  <div class="financies">
    <transition
      appear
      appear-active-class="animated faster fadeIn"
      mode="out-in"
      enter-active-class="animated faster fadeIn"
      leave-active-class="animated faster fadeOut"
    >
      <router-view></router-view>
    </transition>
  </div>
</template>
<script>
import { mapMutations, mapActions } from 'vuex';
import FinancesMiniTable from '@/components/community/FinancesMiniTable';
import TableCommunityFinances from '@/components/table/TableCommunityFinances.vue';
import { financesInstance } from '@/axios/axios.js';

export default {
  name: 'CommunityFinances',
  components: {
    financesMiniTable: FinancesMiniTable,
    tableCommunityFinances: TableCommunityFinances
  },
  data() {
    return {};
  },
  created() {
    // alerts Community view that card is opened so
    // proper badge is loaded
    this.setTableBadge('fas fa-cash-register');
    this.cardOpened();
  },
  mounted() {},
  methods: {
    ...mapMutations(['cardOpened', 'cardClosed']),
    ...mapMutations('table', ['setTableBadge', 'unsetTableData'])
  },
  destroyed() {
    //unsetting badge when view is closed
    //this.unsetTableData();
    this.setTableBadge('');
    this.cardClosed();
  }
};
</script>
<style scoped lang="scss">
.financies {
  height: calc(100% - 170px);
}
</style>
